import React from "react";
import * as C from "./styles";
import DashboardTemplate from "../../components/DashboardTemplate";
import {
  useGetComprovanteByNumpedMutation,
  useGetDatasDisponiveisQuery,
  useGetLimiteAgendamentoByDataMutation,
  useGetLimiteAgendamentosQuery,
  useGetPedidoItemsByNumpedMutation,
  usePostAgendamentoMutation,
} from "../../redux/api/api";
import DataTable, { TableColumn } from "react-data-table-component";
import { useForm, FormProvider, set } from "react-hook-form";
import FlexContainer from "../../components/FlexContainer";
import FormInput from "../../components/FormInput";
import { PiMagnifyingGlassThin } from "react-icons/pi";
import {
  AgendamentoPayload,
  GetComprovante,
  GetPedidoItems,
} from "../../types/agendarTypes";
import Counter from "../../components/Counter";
import Loading from "../../components/Loading";
import FormButton from "../../components/FormButton";
import Calendar from "react-calendar";
import "./calendar.css";
import SectionTitle from "../../components/SectionTitle";
import { toast } from "react-toastify";
import { BsChevronLeft } from "react-icons/bs";
import moment from "moment";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FormRadio from "../../components/FormRadio";
import useNavigateToPdf from "../../hooks/useNavigateToPdf";
import { AiFillPrinter } from "react-icons/ai";

type Form = {
  numped: string;
};

type ThirdStepForm = {
  nomeTransportadora: string;
  numeroNotaFiscal: string;
  dataVencimentoNotaFiscal: string;
  cnpj: string;
  valorNotaFiscal: string;
  freteFOB: boolean;
  freteCIF: boolean;
  pesoInformado: string;
  qtpalInformado: string;
};

const schema = yup.object().shape({
  nomeTransportadora: yup.string().required("O campo é obrigatório!"),
  numeroNotaFiscal: yup
    .number()
    .typeError("São permitidos apenas números")
    .required("O campo é obrigatório!"),
  dataVencimentoNotaFiscal: yup.string().required("O campo é obrigatório!"),
  cnpj: yup
    .string()
    .matches(/^\d+$/, "São permitidos apenas números")
    .typeError("São permitidos apenas números")
    .required("O campo é obrigatório!")
    .test("cnpj", "O campo deve ter 14 dígitos!", (value) => {
      if (value?.toString().length === 14) {
        return true;
      } else {
        return false;
      }
    }),
  valorNotaFiscal: yup
    .number()
    .required("O campo é obrigatório!")
    .typeError("São permitidos apenas números"),
  freteFOB: yup.boolean(),
  freteCIF: yup.boolean(),
  qtpalInformado: yup
    .number()
    .typeError("São permitidos apenas números")
    .required(" O campo é obrigatório!"),
  pesoInformado: yup
    .number()
    .typeError("São permitidos apenas números")
    .required(" O campo é obrigatório!"),
});

export default function AgendarPage() {
  const { navigateToPdf } = useNavigateToPdf();
  const [getPedidoItems, resultGetPedidoItems] =
    useGetPedidoItemsByNumpedMutation();
  const [pedidoItemsData, setPedidoItemsData] = React.useState<
    GetPedidoItems[]
  >([]);
  const [getLimiteByDate, resultGetLimiteByDate] =
    useGetLimiteAgendamentoByDataMutation();
  const [limiteByDate, setLimiteByDate] = React.useState<
    { PAL_TOTAL: number; PESO_TOTAL: number }[]
  >([]);
  const numpedRef = React.useRef<number>(0);
  const { data: datasDiposniveisData } = useGetDatasDisponiveisQuery();
  const [selectedData, setSelectedData] = React.useState<
    (GetPedidoItems & { QT_SELEC: number })[]
  >([]);
  const thirdStepMethods = useForm<ThirdStepForm>({
    resolver: yupResolver(schema),
  });
  const { data: limiteAgendamentosData } = useGetLimiteAgendamentosQuery();
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const methods = useForm<Form>();
  React.useEffect(() => {
    methods.setValue("numped", methods.watch("numped").replace(/\D+/g, ""));
  }, [methods.watch("numped")]);
  const [step, setStep] = React.useState<number>(1);
  const [selectedDate, setSelectedDate] = React.useState<Date>();
  const [getComprovante, resultGetComprovante] =
    useGetComprovanteByNumpedMutation();
  const [comprovanteData, setComprovanteData] = React.useState<
    GetComprovante[]
  >([]);

  const [postAgendamento, resultPostAgendamento] = usePostAgendamentoMutation();
  const clearState = (cb?: () => any) => {
    setSelectedData([]);
    setSelectedDate(undefined);
    setStep(1);
    setPedidoItemsData([]);
    methods.reset();
    cb && cb();
  };
  const onSubmit = (data: Form) => {
    clearState();
    if (data.numped.length > 0) {
      getPedidoItems({ numped: +data.numped })
        .unwrap()
        .then((res) => {
          setPedidoItemsData(res);
          if (res.length > 0) {
            setShowModal(true);
          }
        })
        .catch(() => {
          console.log("erro de conexão");
        });
    }
  };

  React.useEffect(() => {
    if (methods.watch("numped").length > 0) {
      numpedRef.current = +methods.watch("numped");
    }
  }, [methods.watch("numped")]);

  React.useEffect(() => {
    if (thirdStepMethods.watch("freteCIF")) {
      thirdStepMethods.setValue("freteFOB", false);
    }
  }, [thirdStepMethods.watch("freteCIF")]);

  React.useEffect(() => {
    if (thirdStepMethods.watch("freteFOB")) {
      thirdStepMethods.setValue("freteCIF", false);
    }
  }, [thirdStepMethods.watch("freteFOB")]);

  const onSubmitStepThree = (data: ThirdStepForm) => {
    if (data.freteCIF && data.freteFOB) {
      toast.error("Selecione apenas um tipo de frete!");
      return;
    }
    if (!data.freteCIF && !data.freteFOB) {
      toast.error("Selecione um tipo de frete!");
      return;
    }
    console.log(data);
    let payload: AgendamentoPayload[] = selectedData.map((item) => ({
      codfornec: item.CODFORNEC,
      codprod: item.CODPROD,
      numnota: +data.numeroNotaFiscal,
      peso: item.PESOBRUTO * item.QT_SELEC,
      qtentregue: item.QT_SELEC,
      qtpal: item.QT_SELEC / item.QTUNITCX / item.QTTOTPAL,
      tipofrete: data.freteCIF ? "c" : "f",
      vltotal: +data.valorNotaFiscal,
      cnpj_transp: data.cnpj,
      data_descarga: moment(selectedDate).format("DD/MMM/YYYY"),
      data_vencimento: moment(data.dataVencimentoNotaFiscal).format(
        "DD/MMM/YYYY"
      ),
      dtagenda: moment().format("DD/MMM/YYYY"),
      numped: numpedRef.current,
      transportadora: data.nomeTransportadora,
      peso_informado: +data.pesoInformado,
      qtpal_informado: +data.qtpalInformado,
    }));

    postAgendamento({ payload: payload })
      .unwrap()
      .then(() => {
        toast.success("Agendamento realizado com sucesso!");
        getComprovante({
          numped: +numpedRef.current,
        })
          .unwrap()
          .then((res) => {
            setComprovanteData(res);
            setStep(4);
          });
      });
  };
  const pdfData = (
    data: GetComprovante[]
  ): (Pick<
    GetComprovante,
    | "CNPJ_TRANSP"
    | "DATA_VENCIMENTO"
    | "DTAGENDA"
    | "FORNECEDOR"
    | "TIPOFRETE"
    | "TRANSPORTADORA"
    | "DATA_DESCARGA"
    | "DESCRICAO"
  > & { VLTOTAL: string })[] => {
    return data
      .filter((item) => item.DTAGENDA == moment().format("DD/MMM/YYYY"))
      .map((item) => ({
        CNPJ_TRANSP: item.CNPJ_TRANSP,
        DATA_VENCIMENTO: moment(item.DATA_VENCIMENTO).format("DD/MM/YYYY"),
        DTAGENDA: moment(item.DTAGENDA).format("DD/MM/YYYY"),
        FORNECEDOR: item.FORNECEDOR,
        TIPOFRETE: item.TIPOFRETE,
        TRANSPORTADORA: item.TRANSPORTADORA,
        VLTOTAL: item.VLTOTAL?.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        }),
        DESCRICAO: item.DESCRICAO,
        DATA_DESCARGA: moment(item.DATA_DESCARGA).format("DD/MM/YYYY"),
      }));
  };
  console.log(datasDiposniveisData);
  const fourthStepColumns: TableColumn<GetComprovante>[] = [
    {
      name: "DESCRICAO",
      selector: (row) => row.DESCRICAO,
      style: {
        "& div:first-child": {
          whiteSpace: "normal",
        },
      },
    },
    {
      name: "CNPJ",
      selector: (row) => row.CNPJ_TRANSP,
      style: {
        "& div:first-child": {
          whiteSpace: "normal",
        },
      },
    },
    {
      name: "Data Vencimento",
      selector: (row) => moment(row.DATA_VENCIMENTO).format("DD/MM/YYYY"),
      style: {
        "& div:first-child": {
          whiteSpace: "normal",
        },
      },
    },
    {
      name: "Dt Entrega",
      selector: (row) => moment(row.DTAGENDA).format("DD/MM/YYYY"),
      style: {
        "& div:first-child": {
          whiteSpace: "normal",
        },
      },
    },
    {
      name: "Fornec.",
      selector: (row) => row.FORNECEDOR,
      style: {
        "& div:first-child": {
          whiteSpace: "normal",
        },
      },
    },
    {
      name: "Frete.",
      selector: (row) => row.TIPOFRETE,
    },
    {
      name: "Transp.",
      selector: (row) => row?.TRANSPORTADORA ?? "Não informado",
      style: {
        "& div:first-child": {
          whiteSpace: "normal",
        },
      },
    },
    {
      name: "Valor Total",
      selector: (row) =>
        row?.VLTOTAL?.toLocaleString("pt-br", {
          currency: "BRL",
          style: "currency",
        }) ?? "Não informado",
    },
  ];
  console.log(selectedData);
  const columns: TableColumn<GetPedidoItems>[] = [
    {
      name: "Forn.",
      selector: (row) => row.FORNECEDOR,
      style: {
        "& div:first-child": {
          whiteSpace: "normal",
        },
      },
    },
    {
      name: "Descrição",
      selector: (row) => row.DESCRICAO,
      style: {
        "& div:first-child": {
          whiteSpace: "normal",
        },
      },
    },
    {
      name: "Qt. Pedida",
      selector: (row) => row.QTPEDIDA,
    },
    {
      name: "Qt. Entregue",
      cell: (row) => (
        <Counter
          onValueChange={(val) => {
            if (val > 0) {
              if (selectedData.find((item) => item.CODPROD === row.CODPROD)) {
                setSelectedData(
                  selectedData.map((item) =>
                    item.CODPROD === row.CODPROD
                      ? { ...item, QT_SELEC: val }
                      : item
                  )
                );
              } else {
                setSelectedData([...selectedData, { ...row, QT_SELEC: val }]);
              }
            } else {
              setSelectedData(
                selectedData.filter((item) => item.CODPROD !== row.CODPROD)
              );
            }
          }}
          maxVal={row.QTPEDIDA}
        />
      ),
    },
  ];

  if (step == 1) {
    return (
      <DashboardTemplate>
        <C.MainContainer>
          <SectionTitle title="Agendar - ~ Etapa 1 de 4" />
          <FlexContainer customStyle={{ gap: 15, paddingTop: 30 }}>
            <FormProvider {...methods}>
              <C.Form onSubmit={methods.handleSubmit(onSubmit)}>
                <FormInput
                  containerStyle={{ maxWidth: "50%" }}
                  placeholder="Informar N° do Pedido"
                  formName="numped"
                  icon={<PiMagnifyingGlassThin />}
                />
              </C.Form>
            </FormProvider>
            <C.Divider />
            {!!!resultGetPedidoItems.isLoading && (
              <DataTable
                style={{ width: "100%" }}
                columns={columns}
                noDataComponent={
                  !!!resultGetPedidoItems.isUninitialized
                    ? "Nenhum item encontrado"
                    : ""
                }
                data={pedidoItemsData}
                pagination
                paginationComponentOptions={{
                  rowsPerPageText: "Itens por página",
                  rangeSeparatorText: "de",
                  selectAllRowsItem: true,
                  selectAllRowsItemText: "Todos",
                }}
              />
            )}
            {resultGetPedidoItems.isLoading && <Loading />}

            {pedidoItemsData.length > 0 && (
              <FormButton
                text="próximo"
                customStyle={{ width: "120px", alignSelf: "flex-end" }}
                onClick={() => {
                  setStep(2);
                }}
                disabled={!!!selectedData.length}
              />
            )}
          </FlexContainer>
          {showModal && (
            <C.ModalOverlay>
              <C.ModalMainContainer>
                <C.WarnIconContainer>
                  <C.WarnIcon />
                  <C.WarnLabel>LEIA COM ATENÇÃO!</C.WarnLabel>
                </C.WarnIconContainer>

                <C.ModalListContainer>
                  <C.ModalListItem>
                    O preenchimento de todos os campos é obrigatório;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    Caso já existam agendamentos para o dia selecionado, o
                    agendamento anterior será sobrescrito;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    Caso o caminhão chegue antes do dia agendado e a Logistica
                    estiver em condições de receber, será cobrado R$ 10,00 cada
                    pallet;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    Se o caminhão chegar para descarregar sem agendamento e a
                    Logistica estiver em condições de receber, será cobrado R$
                    20,00 cada pallet;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    CARGA VALOR POR TONELADA R$ 22,00;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    CARGA PALETIZADA POR PALLET R$ 10,00;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    CARGA BATIDA POR PALLET R$ 14,00;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    CARGA POR VOLUME R$00,30 CENTAVOS;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    Fica PROIBIDA a entrada de "CHAPA" ou "AJUDANTE" junto com o
                    motorista;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    Dúvidas devem ser retiradas com o Sr. Emerson pelo telefone
                    (45) 3321-6003;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    O motorista deverá apresentar a nota fiscal na portaria da
                    empresa até as 10 (dez) horas da manhã do dia do
                    agendamento. Caso contrário, ficará a critério da logistica
                    / expedição aceitar ou não a descarga do seu carregamento;
                  </C.ModalListItem>
                  <C.ModalListItem>
                    A descarga dos caminhões é A PARTIR DAS 08:00H da manhã
                    seguindo o critério de ordem de chegada, salvo exceções por
                    problemas na nota, caso isso ocorra, será passado o segundo
                    caminhão.
                  </C.ModalListItem>
                  <FormButton
                    customStyle={{
                      margin: 0,
                      width: 200,
                      alignSelf: "flex-end",
                    }}
                    onClick={() => setShowModal(false)}
                    text="Concordar e prosseguir"
                  />
                </C.ModalListContainer>
              </C.ModalMainContainer>
            </C.ModalOverlay>
          )}
        </C.MainContainer>
      </DashboardTemplate>
    );
  } else if (step == 2) {
    return (
      <DashboardTemplate>
        <C.MainContainer>
          <SectionTitle title="Agendar - ~ Etapa 2 de 4" />
          <FlexContainer customStyle={{ gap: 15, paddingTop: 30 }}>
            {!!!selectedDate && (
              <C.CalendarLabel>Selecionar a data da entrega</C.CalendarLabel>
            )}
            {!!selectedDate && (
              <C.CalendarLabel>
                Entrega em: {moment(selectedDate).format("DD/MM/YYYY")}
              </C.CalendarLabel>
            )}
            {datasDiposniveisData?.length && (
              <Calendar
                minDate={new Date(datasDiposniveisData[0].DATA)}
                maxDate={
                  new Date(
                    datasDiposniveisData[datasDiposniveisData.length - 1].DATA
                  )
                }
                onClickDay={(date) => {
                  setSelectedDate(date);
                  getLimiteByDate({
                    dtagenda: moment(date).format("DD-MM-YYYY"),
                  })
                    .unwrap()
                    .then(setLimiteByDate);
                }}
                tileDisabled={({ date }) => {
                  return !!datasDiposniveisData.find(
                    (data) =>
                      !!datasDiposniveisData.find(
                        (data) =>
                          moment(data.DATA).valueOf() === moment(date).valueOf()
                      )?.DISPONIVEL ||
                      date.getDay() + 1 === 7 ||
                      date.getDay() + 1 == 1
                  );
                }}
              />
            )}

            <C.RowWrapper>
              <FormButton
                text="Voltar"
                customStyle={{ width: "120px", alignSelf: "flex-end" }}
                onClick={() => {
                  clearState(() => setStep(1));
                }}
                disabled={!!!selectedData.length}
                icon={<BsChevronLeft />}
              />
              <FormButton
                text={
                  resultGetLimiteByDate.isLoading ? "Carregando..." : "Próximo"
                }
                customStyle={{ width: "130px", alignSelf: "flex-end" }}
                onClick={() => {
                  if (selectedDate && limiteByDate.length > 0) {
                    let dayLimit = limiteAgendamentosData?.find(
                      (item) => item.DIASEMANA === selectedDate.getDay() + 1
                    );
                    if (!!!dayLimit) {
                      toast.error(
                        `Não foi possível verificar os parâmetros de limite de peso! Verifique a sua conexão.`
                      );
                      return;
                    }
                    const pesoTotal = selectedData.reduce(
                      (acc, item) => acc + item.PESOBRUTO * item.QT_SELEC,
                      0
                    );
                    const totalPal = selectedData.reduce(
                      (acc, item) =>
                        acc +
                        (item.QT_SELEC / item.QTUNITCX / item.QTTOTPAL ?? 1),
                      0
                    );

                    if (
                      pesoTotal + limiteByDate[0].PESO_TOTAL >
                      dayLimit.PESO
                    ) {
                      toast.error(
                        `O peso total dos itens selecionados excede o limite para o dia selecionado! Escolha outro dia ou marque menos itens.`
                      );
                      return;
                    }
                    if (
                      totalPal + limiteByDate[0].PAL_TOTAL >
                      dayLimit.QTPALET
                    ) {
                      toast.error(
                        `O número total de pallets dos itens selecionados excede o limite para o dia selecionado! Escolha outro dia ou marque menos itens.`
                      );
                      return;
                    }

                    setStep(3);
                  }
                }}
                disabled={!!!selectedDate || resultGetLimiteByDate.isLoading}
              />
            </C.RowWrapper>
          </FlexContainer>
        </C.MainContainer>
      </DashboardTemplate>
    );
  } else if (step == 3) {
    return (
      <DashboardTemplate>
        <C.MainContainer>
          <SectionTitle title="Agendar - ~ Etapa 3 de 4" />
          <FlexContainer customStyle={{ gap: 15, paddingTop: 30 }}>
            <FormProvider {...thirdStepMethods}>
              <C.Form
                style={{ gap: 25 }}
                onSubmit={thirdStepMethods.handleSubmit(onSubmitStepThree)}
              >
                <C.RowContainer>
                  <FormInput<ThirdStepForm>
                    formName={"nomeTransportadora"}
                    error={
                      !!thirdStepMethods.formState.errors.nomeTransportadora
                    }
                    errorMsg={
                      thirdStepMethods.formState.errors.nomeTransportadora
                        ?.message
                    }
                    placeholder="Nome da transportadora"
                  />
                  <FormInput<ThirdStepForm>
                    type="number"
                    formName={"numeroNotaFiscal"}
                    error={!!thirdStepMethods.formState.errors.numeroNotaFiscal}
                    errorMsg={
                      thirdStepMethods.formState.errors.numeroNotaFiscal
                        ?.message
                    }
                    placeholder="N° da nota fiscal"
                  />
                </C.RowContainer>
                <C.RowContainer>
                  <FormInput<ThirdStepForm>
                    type="number"
                    formName={"pesoInformado"}
                    error={!!thirdStepMethods.formState.errors.pesoInformado}
                    errorMsg={
                      thirdStepMethods.formState.errors.pesoInformado?.message
                    }
                    placeholder="Peso total (Kg)"
                  />
                  <FormInput<ThirdStepForm>
                    type="number"
                    formName={"qtpalInformado"}
                    error={!!thirdStepMethods.formState.errors.qtpalInformado}
                    errorMsg={
                      thirdStepMethods.formState.errors.qtpalInformado?.message
                    }
                    placeholder="Total de pallets"
                  />
                </C.RowContainer>
                <C.RowContainer>
                  <FormInput<ThirdStepForm>
                    type="number"
                    formName={"cnpj"}
                    error={!!thirdStepMethods.formState.errors.cnpj}
                    errorMsg={thirdStepMethods.formState.errors.cnpj?.message}
                    placeholder="CNPJ do fornecedor (apenas números)"
                  />
                  <FormInput<ThirdStepForm>
                    type="number"
                    formName={"valorNotaFiscal"}
                    error={!!thirdStepMethods.formState.errors.valorNotaFiscal}
                    errorMsg={
                      thirdStepMethods.formState.errors.valorNotaFiscal?.message
                    }
                    placeholder="Valor da nota fiscal (R$)"
                  />
                </C.RowContainer>
                <C.RowContainer>
                  <FormInput<ThirdStepForm>
                    type="date"
                    formName={"dataVencimentoNotaFiscal"}
                    error={
                      !!thirdStepMethods.formState.errors
                        .dataVencimentoNotaFiscal
                    }
                    errorMsg={
                      thirdStepMethods.formState.errors.dataVencimentoNotaFiscal
                        ?.message
                    }
                    placeholder="Data de vencimento da nota fiscal"
                  />
                </C.RowContainer>

                <C.RadioContainer>
                  <FormRadio<ThirdStepForm>
                    formName={"freteFOB"}
                    label="Frete FOB"
                    containerStyle={{
                      width: "200px",
                      justifyContent: "flex-start",
                    }}
                  />
                  <FormRadio<ThirdStepForm>
                    formName={"freteCIF"}
                    label="Frete CIF"
                    containerStyle={{
                      width: "200px",
                      justifyContent: "flex-start",
                    }}
                  />
                </C.RadioContainer>
                <FormButton
                  text="Finalizar"
                  type="submit"
                  customStyle={{ width: "120px", alignSelf: "flex-end" }}
                  onClick={() => {
                    if (selectedDate) {
                      setStep(3);
                    }
                  }}
                  disabled={!!!selectedDate || resultPostAgendamento.isLoading}
                />
              </C.Form>
            </FormProvider>
          </FlexContainer>
        </C.MainContainer>
      </DashboardTemplate>
    );
  } else if (step == 4) {
    return (
      <DashboardTemplate>
        <C.MainContainer>
          <SectionTitle title="Agendar - ~ Etapa 4 de 4" />
          <FlexContainer customStyle={{ gap: 15, paddingTop: 30 }}>
            {!!!resultGetComprovante.isLoading && (
              <DataTable
                style={{ width: "100%" }}
                columns={fourthStepColumns}
                noDataComponent={
                  !!!resultGetComprovante.isUninitialized
                    ? "Nenhum item encontrado"
                    : ""
                }
                data={comprovanteData.filter(
                  (item) => item.DTAGENDA == moment().format("DD/MMM/YYYY")
                )}
                pagination
                paginationComponentOptions={{
                  rowsPerPageText: "Itens por página",
                  rangeSeparatorText: "de",
                  selectAllRowsItem: true,
                  selectAllRowsItemText: "Todos",
                }}
              />
            )}
            {resultGetComprovante.isLoading && <Loading />}

            {comprovanteData.length > 0 && (
              <FormButton
                text="imprimir"
                customStyle={{ width: "120px", alignSelf: "flex-end" }}
                onClick={() => {
                  navigateToPdf({
                    data: pdfData(
                      comprovanteData.filter(
                        (item) =>
                          item.DTAGENDA == moment().format("DD/MMM/YYYY")
                      )
                    ),
                    title: "Comprovante de Agendamento",
                  });
                }}
                iconAtEnd
                icon={<AiFillPrinter />}
              />
            )}
          </FlexContainer>
        </C.MainContainer>
      </DashboardTemplate>
    );
  } else {
    return <>Etapa inexistente!</>;
  }
}
